import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GeaoContext } from '../../../GeaoContextProvider';
import { GeaoPaths } from '../../../constants/GeaoPaths';

export default function useNavigation(
    interviewsUpdated,
    exitAfterSave
) {
    const { agencyInterview } = useContext(GeaoContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (!interviewsUpdated) return; // Only navigate if the interview update was successful.

        navigate(exitAfterSave ?
            GeaoPaths.CreateYourProfileChecklist :
            GeaoPaths.PrincipalAgencyFinancialInformation);

    }, [agencyInterview, interviewsUpdated, exitAfterSave]);
}